import React, { Component, Dispatch, createRef } from 'react';
import { connect } from 'react-redux';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import Loading from '../../components/loading/loading';
import { ChatPanelItem } from './chatPanelItem';
import { IMessage, IMessageRequest } from '../../models/pages/messages';
import * as Actions from '../../store/actions/messages';
import { SecureImage } from '../../components/core/secureImage';
import { MessagesService } from '../../api/message-services';
import { FileUpload } from '../../components/file-upload/main';
import { IAction, IAppState } from '../../models/action/core';
import { Guid } from 'guid-typescript';
import ChatEmojiPicker from './chatEmojiPicker';
import ContentProviders from './contentProviders';
import ContentLoader from 'react-content-loader';
import { EModuleType } from '../../models/components/input-quil.d';
import Quil from '../../components/input/quil/main';
import { Confirm } from '../../components/notification/main';
import { MessageDeletionType } from '../../models/enums/MessageDeletionType';
import { Modal } from 'reactstrap';
import Tooltip from '../../components/tooltip/main';
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
const T = Translator.create();
const _logger = Log.create('Message Page chatPanel');
let _common: Common;
const messagesService = new MessagesService();

const defaultChatLogo = `${process.env.PUBLIC_URL}/images/message/message.jpg`;
const endRef = createRef<HTMLDivElement>();
export class CChatPanel extends Component<any, any> {
    public state = {
        messageBody: {} as { [key: string]: string },
        fileId: '',
        showEmojiPicker: false,
        showFileUploader: false,
        showFileUploaderCount: 0,
        fileUploaded: false,
        fileUploadKey: '',
        textAreaValue: '',
        mobileChatPanelActive: true,
        getQuillToolbarModule: EModuleType.basic,
        isLoadingProcess: false,
        isMessageSent: false
    };

    chatEmojiPicker: any;
    chatInput: HTMLDivElement | null = null;
    emojiPicker: Picker | null = null;
    comp: any = this;
    timerForUpdatingChatItems: number = 0;
    timerForScrollToBottom: number = 0;
    conversationContainer: HTMLDivElement | null = null;
    keepSettingScrollbarToBottom: boolean = true;
    uppyInstance: any;
    maximumAllowedMessageLength: number = 2000;
    divMessageLengthNotification: HTMLDivElement | null = null;
    isPasting: boolean = false;
    contentProviders: ContentProviders;
    quillRef: Quil | null = null;
    quillRef_popUp: Quil | null = null;

    constructor(props: any) {
        super(props);
        this.contentProviders = new ContentProviders();
        _common = new Common();
        this.state.fileUploadKey = this.generateFileUploadKey();
        this.state.mobileChatPanelActive = true;
    }
    sendHandler = (isPopUp: boolean) => {
        if(this.state.isMessageSent)
        {
            return;
        }
        this.setState({isMessageSent: true})
        this.setState({ isLoadingProcess: true })
        if (!this.state.textAreaValue) {
            return;
        }
        let messageText = this.state.textAreaValue.replace(/(<p><br><\/p>)+$/, '').trim();
        messageText = this.trimMessage(messageText);
        if (!this.state.fileUploaded && !this.checkMessageLength(messageText)) {
            return;
        } else if (messageText.length > 0 || this.state.fileUploaded === true) {
            messageText = this.normalizeChatMessage(messageText, true);
        }

        const message: IMessageRequest = {
            body: messageText,
            contextList: [{ contextId: this.props.currentContextId, targetType: this.props.currentContextType }],
            originMessageId: this.props.originMessageId,
            fileUploadId: this.state.fileUploaded ? this.state.fileUploadKey : '',
            hostAddress: window.location.hostname
        };

        this.props.dispatch(Actions.sendMessageAction(message, this.messageCallback));

        this.handleResetText(isPopUp);
    };

    handleResetText(isPopUp: boolean) {
        if (isPopUp) {
            if (this.quillRef_popUp) {
                this.quillRef_popUp.state.description = "";
            }
        } else if (this.quillRef) {
            this.quillRef.state.description = "";

        }

    }

    checkMessageLength(messageText: string) {
        // replace emoji html with emoji colons and strip html tags
        const charCount = this.getCharacterCount(messageText);

        if (!this.divMessageLengthNotification) {
            return;
        }

        if (charCount > this.maximumAllowedMessageLength) {
            this.divMessageLengthNotification.innerText = T.t('r_message_char_length_exceeded_warning').replace(
                '{0}',
                charCount - this.maximumAllowedMessageLength
            );
            this.divMessageLengthNotification.style.display = '';
            return false;
        } else {
            this.divMessageLengthNotification.innerText = '';
            this.divMessageLengthNotification.style.display = 'none';

            return charCount > 0;
        }
    }

    normalizeChatMessage(messageText: string, includeProvidedContent: boolean = false) {
        // clean all html tags
        // messageText = messageText.replace(/<[^>]+>/gi, ' ');
        messageText = messageText.replace(/<script/gi, '&lt;script').replace(/<\/script/gi, '&lt;/script');

        // clean line-breaks at start and end
        messageText = messageText.replace(/(^(\n|\r)+)|((\n|\r)+$)/gi, '');
        messageText = messageText.replace(/(^(<br\/*>)+)|((<br\/*>)+$)/gi, '');

        // trim whitespace
        messageText = messageText.replace(/^\s*(\S+)\s*$/gi, '$1');

        // don't allow double spaces
        messageText = messageText.replace(/&nbsp;&nbsp;/gi, '&nbsp;');

        if (includeProvidedContent) {
            // include provided contents, links etc.
            messageText = this.contentProviders.getContent(messageText);
        }
        return messageText;
    }

    getCharacterCount(messageText: string): number {
        if (!messageText || messageText.length === 0) {
            return 0;
        }
        const emojiMatches = messageText.match(/<img[^>]+data-emoji="([^"]+)"[^>]*>/gi);
        const emojiCount = emojiMatches ? emojiMatches.length : 0;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = messageText;

        if (tempDiv.innerHTML.includes('<img')) {
            return tempDiv.innerText.trim().length + emojiCount + 1;
        } else {
            return tempDiv.innerText.trim().length + emojiCount;
        }
    }

    trimMessage(messageText: string): string {
        messageText = messageText.replace(/^(\s|(&nbsp;))+/gi, '');
        messageText = messageText.replace(/(\s|(&nbsp;))+$/gi, '');
        return messageText;
    }

    generateFileUploadKey = () => {
        return 'message_upload_' + this.props.identity.userId + '_' + Guid.create();
    };

    getMessageBodyKey = () => {
        return 'mk_' + this.props.originMessageId + '_' + this.props.currentContextId + '_' + this.props.currentContextType;
    };

    getMessageBodyByKey = (key: string) => {
        return this.state.messageBody && this.state.messageBody[key] ? this.state.messageBody[key] : '';
    };

    // navigating through messages and contacts, the message body written but not sent is stored in memory
    // so that, if user clicks on another conversation and returns, the message text that was not sent
    // is displayed again...
    getCurrentMessageBody = () => {
        const currentMessageBody = this.getMessageBodyByKey(this.getMessageBodyKey());
        return currentMessageBody;
    };

    setCurrentMessageBody = (text: string) => {
        this.state.messageBody[this.getMessageBodyKey()] = text;
        return this.state.messageBody;
    };

    resetCurrentMessageBodyFromState = () => {
        const newMessageBody = { ...this.state.messageBody };
        delete newMessageBody[this.getMessageBodyKey()];
        return newMessageBody;
    };

    placeCaretAtEnd = (el: any) => {
        el.focus();
        if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
            const range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            const sel = window.getSelection();
            if (sel) {
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    };

    onChatInputPaste = (e: any) => {
        this.isPasting = true;
    };

    onKeyDown = (e: any) => {
        if (!this.chatInput) {
            return;
        }

        let messageText = this.chatInput.innerHTML;
        if (!this.state.fileUploaded && (!messageText || messageText.length === 0)) {
            return;
        }

        const messageLengthOK = this.checkMessageLength(messageText);
        if (this.isPasting) {
            const normalizedVersion = this.normalizeChatMessage(messageText, true);
            if (messageText !== normalizedVersion) {
                this.chatInput.innerHTML = normalizedVersion;
                // this.placeCaretAtEnd(this.chatInput);
                messageText = normalizedVersion;
            }
            this.isPasting = false;
        }

        if (!e.shiftKey && !e.altKey && e.key === 'Enter' && messageLengthOK) {
            e.preventDefault();
            this.sendHandler(false);
        } else if (messageLengthOK) {
            this.state.messageBody = this.setCurrentMessageBody(e.target.innerHTML);
        } else {
            return false;
        }
    };

    resetFileUploader = () => {
        if (this.uppyInstance) {
            this.uppyInstance.reset();
        }
        this.setState({ fileUploaded: false, fileUploadKey: this.generateFileUploadKey() });
    };

    toggleEmojiPicker = () => {
        this.setState({
            showEmojiPicker: !this.state.showEmojiPicker
        });
    };

    showFileUploader = () => {
        this.setState({
            showFileUploader: true,
            showFileUploaderCount: this.state.showFileUploaderCount + 1
        });
    };

    closeFileUploader = (uppy: any) => {
        this.setState({
            showFileUploader: false
        });
        this.uppyInstance = uppy;
    };

    fileUploadedHandler = (uppy: any) => {
        this.setState({
            fileUploaded: true,
            showFileUploader: false,
            textAreaValue: '<p></p>'
        });
        this.uppyInstance = uppy;
    };

    deleteMessage = () => {
        Confirm.setConfirm(
            'normal',
            () =>
                this.props.dispatch(
                    Actions.getDeleteAllMessages(
                        this.props.originMessageId,
                        MessageDeletionType.MultipleDelete,
                        '',
                        'get',
                        this.refreshMessageList
                    )
                ),
            T.t('r_delete_conversation_with_contact', {
                name: this.props.chatTitleText.length > 30 ? this.props.chatTitleText.slice(0, 30) + '...' : this.props.chatTitleText
            }),
            null
        );
    };

    getConversations = () => {
        this.props.dispatch(
            Actions.getConversationListAction({
                skip: 0,
                take: this.props.messageListTake,
                keyword: '',
                spinnerId: 'getContactConversationsAction',
                spinnerType: 'get',
                isGroup: false,
                callback: this.callback
            })
        );
    };

    callback = () => {
        this.props.dispatch(
            Actions.getConversationListAction({
                skip: 0,
                take: this.props.messageListTake,
                keyword: '',
                spinnerId: 'getGroupConversationsAction',
                spinnerType: 'get',
                isGroup: true
            })
        );
    };

    messageCallback = (data: any) => {
        this.refreshMessageList(data.originMessageId, true)
    }
    refreshMessageList = (originMessageId: string = this.props.originMessageId, isAfterSend: boolean = false) => {
        this.props.dispatch(
            Actions.getMessageListAction({
                skip: 0,
                take: this.props.chatTake + this.props.chatSkip,
                originMessageId,
                contextType: this.props.currentContextType,
                contextId: this.props.currentContextId,
                imageUrl: this.props.chatTitleImages,
                chatTitleText: this.props.chatTitleText,
                spinnerId: !isAfterSend ? 'getMessageListAction' : 'getMessageListAction_aftersend',
                spinnerType: 'get',
                callback: () => {
                    if (endRef.current) {
                        endRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }
                    this.setState({ isLoadingProcess: false })
                }
            })
        );

        if (this.uppyInstance) {
            this.uppyInstance.reset();
        }

        this.setState({
            textAreaValue: '',
            messageBody: this.resetCurrentMessageBodyFromState(),
            emojiPickerVisible: false,
            fileUploaded: false,
            fileUploadKey: this.generateFileUploadKey(),
            isMessageSent: false
        });
    };

    refreshAllLists = () => {
        this.getConversations();
        this.refreshMessageList();
    };

    addEmoji = (emoji: any) => {
        let text = this.state.textAreaValue;
        if (text.endsWith('</p>')) {
            text = text.slice(0, -4);
        }

        this.setState({
            textAreaValue: text + emoji.native + '</p>'
        });
    };

    updateChatItems = (spinnerId?: string) => {
        if (this.props.originMessageId && this.props.originMessageId !== '-1' && this.chatInput && this.chatInput.innerHTML.length === 0) {
            this.props.dispatch(
                Actions.getMessageListAction({
                    skip: 0,
                    take: this.props.chatTake + this.props.chatSkip,
                    originMessageId: this.props.originMessageId,
                    contextType: this.props.currentContextType,
                    contextId: this.props.currentContextId,
                    imageUrl: this.props.chatTitleImages,
                    chatTitleText: this.props.chatTitleText,
                    spinnerId: spinnerId ? spinnerId : 'getMessageListAction',
                    spinnerType: 'get'
                })
            );
        }
    };

    scrollToBottom = () => {
        // set a very big value to scroll to bottom...
        if (endRef.current && this.keepSettingScrollbarToBottom) {
            endRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    };

    handleScrollOfContainer = (e: any) => {
        if (this.conversationContainer) {
            const scrollHeight = this.conversationContainer.scrollHeight;
            const scrollTop = this.conversationContainer.scrollTop;
            const offsetHeight = this.conversationContainer.offsetHeight;
            // prevents unnecessary API calls when all chat messages are already fetched.
            if (scrollTop === 0 && this.props.chatSkip + 10 < this.props.chatTotal) {
                this.props.dispatch(
                    Actions.getLoadMoreMessages({
                        skip: this.props.chatSkip + 10,
                        take: this.props.chatTake,
                        originMessageId: this.props.originMessageId,
                        contextType: this.props.currentContextType,
                        contextId: this.props.currentContextId,
                        imageUrl: this.props.chatTitleImages,
                        chatTitleText: this.props.chatTitleText,
                        spinnerId: 'getMessageListAction',
                        spinnerType: 'get'
                    })
                );
            }
            // if the scroll is set to the bottom manually, then
            // set auto fixing to true
            if (scrollHeight === scrollTop + offsetHeight) {
                this.keepSettingScrollbarToBottom = true;
            } else {
                this.keepSettingScrollbarToBottom = false;
            }
        }
    };

    public componentDidMount() {
        // check messages every 10 seconds
        this.timerForUpdatingChatItems = window.setInterval(this.updateChatItems.bind(this, 'getContentMessageLoadingBox'), 10000);
        this.timerForScrollToBottom = window.setInterval(this.scrollToBottom, 10000);
        this.updateChatItems();
        this.state.getQuillToolbarModule = this.getQuillToolbarModule();

    }

    public componentDidUpdate(prevProps: any) {
        const nodeEnter = document.getElementsByClassName("ql-editor ql-blank")[0];
        const nodeEnterPopUp = document.getElementsByClassName("ql-editor")[0];

        if(nodeEnter)
        {
         
            nodeEnter.addEventListener("keyup", (event:any) => {
            if (event.key === "Enter" && !event.shiftKey) {
                    this.sendHandler(false)
                }
            });
        }
        else if (nodeEnterPopUp)
        {
            nodeEnterPopUp.addEventListener("keyup", (event:any) => {
                if (event.key === "Enter" && !event.shiftKey) {
                        this.sendHandler(true)
                    }
                });
        }
        
        
        if (this.props.originMessageId) {
            // this.placeCaretAtEnd(this.chatInput);
        }
        if (prevProps.chatTitleText !== this.props.chatTitleText) {
            this.keepSettingScrollbarToBottom = true;
        }
        if (this.props.messages !== prevProps.messages) {
            if (endRef.current) {
                this.scrollToBottom()
            }
        }
    }

    public componentWillUnmount() {
        this.props.dispatch(Actions.setChatPanelMessagesDefault());
        window.clearInterval(this.timerForUpdatingChatItems);
        window.clearInterval(this.timerForScrollToBottom);
    }

    loading(start: number, length: number, float: 'right' | 'left') {
        const loadingSpaces = 190;
        const rows = [];
        for (let index = start; index < length + start; index++) {
            rows.push(
                <>
                    <rect x={float === 'right' ? '75.9%' : '1.5%'} y={20 + loadingSpaces * index} rx="0" ry="0" width="32" height="32" />
                    <rect x={float === 'right' ? '79.5%' : '5.1%'} y={30 + loadingSpaces * index} rx="3" ry="3" width="8%" height="10" />
                    <rect x={float === 'right' ? '88.5%' : '14.1%'} y={30 + loadingSpaces * index} rx="3" ry="3" width="7.3%" height="10" />
                    <rect x={float === 'right' ? '75.9%' : '1.5%'} y={65 + loadingSpaces * index} rx="5" ry="5" width="20%" height="15%" />
                </>
            );
        }

        return rows;
    }

    messageOnChange = (event: any) => {
        if (event !== this.state.textAreaValue) {
            this.setState({ textAreaValue: event });
        }
    };
    setClose = (refresh: boolean = false) => {
        if (this.props.onClose) {
            this.props.onClose(refresh);
        }
    };
    setCloseModal = () => {
        this.setClose();
    };

    changeActive = () => {
        const item = document.getElementById('chatPanel');
        if (item) {
            item.className = 'conversation-window relative mobile_chat_panel display_sm_none';
        }
        const itemChatList = document.getElementById('currentChatListPanel');
        if (itemChatList) {
            itemChatList.className = 'custom-col-forum-1 display_sm';
        }
    };

    getQuillToolbarModule = () => {
        return (window.innerWidth > 760) ? EModuleType.basic : EModuleType.mobile
    };

    public render() {

        if (!this.props.originMessageId || this.props.isMessageModelOpen || this.props.messageModelClosed) {
            if (this.props.isSubmain) {
                return (
                    <div>
                        {/* <ContentLoader
                        speed={1}
                        width={700}
                        height={150}
                        viewBox="0 0 700 150"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                    >
                        <circle cx="19" cy="25" r="18" />
                        <rect x="40" y="20" rx="5" ry="5" width="220" height="12" />


                        <circle cx="19" cy="90" r="18" />
                        <rect x="40" y="90" rx="0" ry="0" width="165" height="7" />
                        <rect x="0" y="115" rx="0" ry="0" width="680" height="10" />
                        <rect x="0" y="132" rx="0" ry="0" width="680" height="10" />
                        <rect x="0" y="149" rx="0" ry="0" width="680" height="10" />
                    </ContentLoader> */}
                    </div>
                );
            } else {
                return (
                    <div className="create-announcement text-center" id="blankChatPanelText">
                        <div className="d-flex align-items-center justify-content-center flex-column">
                            <img src={_common.DefaultLogos.message} alt="Message" />
                            <h5 className="mt-4" tabIndex={0}>{T.t('r_menu_messages')}</h5>
                            <p tabIndex={0}>{T.t('r_send_messages_to_chat_or_contact')}</p>
                        </div>
                    </div>
                );
            }
        } else {
            return (
                <>
                    {!this.props.isSubmain && !this.props.isModalOpen ? (
                        <div>
                            <div id="chatPanel" className="conversation-window relative mobile_chat_panel">

                                <div
                                    className="conversation-header d-flex align-items-center justify-content-between"
                                    style={{ padding: '15.5px 20px' }}
                                >
                                    <div className="userinfo media align-items-center">
                                        <span className="group-user-icon mr-1 d-flex" data-id={this.props.originMessageId}>
                                            <a
                                                type="button"
                                                onClick={this.changeActive}
                                                id="backToMesaageList"
                                                className="display_sm_flex"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <i className="material-icons">chevron_left</i>
                                            </a>
                                            {this.props.currentContextType === 0 ?
                                                <SecureImage
                                                    imageUrl={this.props.chatTitleImages}
                                                    key={
                                                        'group-icon-' +
                                                        this.props.originMessageId +
                                                        '-' +
                                                        this.props.currentContextType +
                                                        '-' +
                                                        this.props.currentContextId
                                                    }
                                                    imgType={this.props.currentContextType === 0 ? 'avatar' : 'course'}
                                                /> : <img className="chat_avatar" src={defaultChatLogo} />}
                                        </span>
                                        <div className="media-body">
                                            {this.props.chatTitleText.length > 80 ? (
                                                <div className="list-icons">
                                                    <Tooltip data={this.props.chatTitleText} position='top'>
                                                        <span>
                                                            {this.props.chatTitleText.length > 80
                                                                ? this.props.chatTitleText.slice(0, 80) + '...'
                                                                : this.props.chatTitleText}
                                                        </span>
                                                    </Tooltip>
                                                </div>
                                            ) : (
                                                <span>{this.props.chatTitleText}</span>
                                            )}
                                        </div>
                                    </div>
                                    {this.props.messages.length ? (
                                        <div className="dropdown own-dropdown">
                                            <a data-toggle="dropdown" href="javascript:;">
                                                <img src={_common.GetDefaultIcons('dots')} alt="Dots" />
                                            </a>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton">
                                                <a className="dropdown-item" href="javascript:;" onClick={this.deleteMessage}>
                                                    {T.t('r_delete_conversation')}
                                                </a>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>

                                {/*<div className="announcement-stats border-bottom pb-3 mb-4 mt-2">.</div>*/}
                                <div
                                    className="conversation-container"
                                    onScroll={this.handleScrollOfContainer}
                                    ref={el => (this.conversationContainer = el)}
                                >
                                    <Loading spinnerId={'getMessageListAction'} height={'100%'}>
                                        <div style={{ backgroundColor: '#fbfaf6', height: '100%' }}>
                                            <ContentLoader
                                                speed={2}
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb"
                                                style={{ width: '100%', height: '100%' }}
                                                preserveAspectRatio="xMinYMin meet"
                                            >
                                                {this.loading(0, 2, 'right')}
                                                {this.loading(2, 2, 'left')}
                                            </ContentLoader>
                                        </div>
                                    </Loading>
                                    <div
                                        id="getMessageListAction_Content_Flex"
                                        className="conversations scroll-smooth"
                                        style={{ marginTop: '12px' }}
                                    >
                                        <Loading spinnerId={'getContentMessageLoadingBox'} type={'box'} bottom={100} position={'fixed'} />
                                        <div id="lastmessage" />
                                        {this.props.messages && this.props.messages.length > 0 ? (
                                            this.props.messages.map((m: IMessage) => {
                                                if (m.userId === this.props.identity.userId) {
                                                    m.imageUrl = this.props.identity.profileImagePath;
                                                    m.isOwnMessage = true;
                                                }
                                                return <ChatPanelItem {...m} key={m.messageId} refreshPage={this.refreshAllLists} />;
                                            })
                                        ) : (
                                            <div className="create-announcement text-center">
                                                <div className="d-flex align-items-center justify-content-center flex-column">
                                                    <img src={_common.DefaultLogos.message} alt="Message" />
                                                    <h5 className="mt-4">{T.t('r_menu_messages')}</h5>
                                                    <p>{T.t('r_no_messages_here_yet')}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div ref={endRef} />
                                    <FileUpload
                                        key={this.state.fileUploadKey}
                                        fileInputKey={this.state.fileUploadKey}
                                        height={250}
                                        maxFileSize={10000000}
                                        maxSelectedFileCount={1}
                                        isCardImage={false}
                                        isModal={true}
                                        modalOpen={this.state.showFileUploader}
                                        handleModalClose={this.closeFileUploader}
                                        triggerFileUpload={this.fileUploadedHandler}
                                    />
                                </div>
                                <div className="type-message-field w-100  message-field-position" style={{ padding: '5px 0' }}>
                                    <div className="input-group d-block" style={{ padding: '0 5px' }}>
                                        <div
                                            style={{ display: 'none' }}
                                            ref={e => {
                                                this.divMessageLengthNotification = e;
                                            }}
                                            className="message-input-warning"
                                        />
                                        <Quil
                                            ref={ref => { this.quillRef = ref }}
                                            modules={this.getQuillToolbarModule()}
                                            placeholder={T.t('r_message_place_holder')}
                                            // tslint:disable-next-line
                                            onChange={this.messageOnChange}
                                            className={'custom-quill-message'}
                                            value={this.state.textAreaValue}
                                            theme={'snow'}
                                        />
                                        {/* <div
                                    contentEditable={true}
                                    className="form-control message-input-text"
                                    placeholder={T.t('r_message_place_holder')}
                                    onKeyDown={this.onKeyDown}
                                    ref={e => (this.chatInput = e)}
                                /> */}
                                        <div className="input-group-append">
                                            {this.state.getQuillToolbarModule !== EModuleType.mobile ? (
                                                <div>
                                                    {this.state.showEmojiPicker ? (
                                                        <ChatEmojiPicker
                                                            onSelect={this.addEmoji}
                                                            handleClickOutside={this.toggleEmojiPicker}
                                                            ref={e => (this.chatEmojiPicker = e)}
                                                            locale={T.i18next.language}
                                                        />
                                                    ) : null}
                                                    <div className='r-d-flex'>
                                                        <span className="input-group-text" onClick={this.toggleEmojiPicker}>
                                                            <i className="material-icons">tag_faces</i>
                                                        </span>

                                                        {this.state.fileUploaded ? (
                                                            <>
                                                                <span className="input-group-text" onClick={this.showFileUploader}>
                                                                    <i className="material-icons">attach_file</i>
                                                                </span>
                                                                <span
                                                                    style={{ height: '16px', color: 'red', marginLeft: '0px', cursor: 'pointer' }}
                                                                    title="Dosyayı sil"
                                                                    className="badge badge-pill badge-light"
                                                                    onClick={this.resetFileUploader}
                                                                >
                                                                    x
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <span className="input-group-text" onClick={this.showFileUploader}>
                                                                <i className="material-icons">add</i>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : null}

                                            <button onClick={() => this.sendHandler(false)} disabled={this.state.isLoadingProcess} className="input-group-text" style={{ border: 'none', background: 'none' }}>
                                                <i
                                                    style={document.body.getAttribute('dir') == 'ltr' ? { marginInlineEnd: "5px" } : { marginInlineEnd: "5px", transform: "scaleX(-1)" }}
                                                    className="material-icons">
                                                    send
                                                </i>
                                                <div style={{ paddingInlineStart: "5px" }}>
                                                    {this.state.isLoadingProcess ? T.t('r_gen_sending') : T.t('r_send')}
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    <Modal
                        id="chatpanel-popup"
                        keyboard={false}
                        isOpen={this.props.isModalOpen}
                        toggle={this.props.triggerModal}
                        contentClassName={' chat_modal_width'}
                        modalClassName={'survey-modal-fade'}
                        zIndex={9999}
                    >
                        <div className="modal-header d-flex justify-content-start mobile_chat_padding " style={{ padding: '.5em 2em' }}>
                            <div className="conversation-header d-flex align-items-center justify-content-between w-100">
                                <div className="userinfo media align-items-center">
                                    <span className="group-user-icon mr-1" data-id={this.props.originMessageId}>
                                        <SecureImage
                                            imageUrl={this.props.chatTitleImages}
                                            key={
                                                'group-icon-' +
                                                this.props.originMessageId +
                                                '-' +
                                                this.props.currentContextType +
                                                '-' +
                                                this.props.currentContextId
                                            }
                                            imgType={this.props.currentContextType === 0 ? 'avatar' : 'course'}
                                        />
                                    </span>
                                    <div className="media-body">
                                        {this.props.chatTitleText.length > 80 ? (
                                            <div className="list-icons">
                                                <Tooltip data={this.props.chatTitleText} position='top'>
                                                    <span>
                                                        {this.props.chatTitleText.length > 80
                                                            ? this.props.chatTitleText.slice(0, 80) + '...'
                                                            : this.props.chatTitleText}
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        ) : (
                                            <span>{this.props.chatTitleText}</span>
                                        )}
                                    </div>
                                </div>

                                {this.props.messages.length ? (
                                    <div className="dropdown popup-conversation-dot">
                                        <a data-toggle="dropdown" onMouseDown={(e) => e.stopPropagation()}>
                                            <img src={_common.GetDefaultIcons('dots')} alt="Dots" />
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a className="dropdown-item" href="javascript:;" onClick={this.deleteMessage}>
                                                {T.t('r_delete_conversation')}
                                            </a>
                                        </div>
                                    </div>
                                ) : null}

                                {this.props.backdrop !== 'static' ? (
                                    <button type="button" className="close ml-0 popup-conversation-button" onClick={this.setCloseModal} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <div className="modal-content">
                            <div className="modal-body p-0">
                                <div className="row" style={{ marginTop: 0 }}>
                                    <div className="col-12">
                                        <div className="conversation-popup relative">
                                            <div
                                                style={{ padding: '0 2em' }}
                                                className="conversation-container"
                                                ref={el => (this.conversationContainer = el)}
                                                onScroll={this.handleScrollOfContainer}
                                            >
                                                <div
                                                    id="getMessageListAction_Content_Flex"
                                                    className="conversations scroll-smooth"
                                                    style={{ marginTop: '12px', height: '60vh' }}
                                                >
                                                    <Loading
                                                        spinnerId={'getContentMessageLoadingBox'}
                                                        type={'box'}
                                                        bottom={100}
                                                        position={'fixed'}
                                                    />
                                                    <div id="lastmessage_popup" />
                                                    {this.props.messages && this.props.messages.length > 0 ? (
                                                        this.props.messages.map((m: IMessage) => {
                                                            if (m.userId === this.props.identity.userId) {
                                                                m.imageUrl = this.props.identity.profileImagePath;
                                                                m.isOwnMessage = true;
                                                            }
                                                            return (
                                                                <ChatPanelItem
                                                                    {...m}
                                                                    key={m.messageId}
                                                                    refreshPage={this.refreshAllLists}
                                                                />
                                                            );
                                                        })
                                                    ) : (
                                                        <div className="create-announcement text-center">
                                                            <div className="d-flex align-items-center justify-content-center flex-column">
                                                                <img src={_common.DefaultLogos.message} alt="Message" />
                                                                <h5 className="mt-4">{T.t('r_menu_messages')}</h5>
                                                                <p>{T.t('r_no_messages_here_yet')}</p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <FileUpload
                                                    key={this.state.fileUploadKey}
                                                    fileInputKey={this.state.fileUploadKey}
                                                    height={250}
                                                    maxFileSize={10000000}
                                                    maxSelectedFileCount={1}
                                                    isCardImage={false}
                                                    isModal={true}
                                                    modalOpen={this.state.showFileUploader}
                                                    handleModalClose={this.closeFileUploader}
                                                    triggerFileUpload={this.fileUploadedHandler}
                                                />
                                            </div>
                                            <div className="type-message-field w-100  message-field-position" style={{ padding: '5px 0' }}>
                                                <div className="input-group d-block" style={{ padding: '0' }}>
                                                    <div
                                                        style={{ display: 'none' }}
                                                        ref={e => {
                                                            this.divMessageLengthNotification = e;
                                                        }}
                                                        className="message-input-warning"
                                                    />
                                                    <Quil
                                                        ref={ref => { this.quillRef_popUp = ref }}
                                                        modules={this.getQuillToolbarModule()}
                                                        placeholder={T.t('r_message_place_holder')}
                                                        // tslint:disable-next-line
                                                        onChange={this.messageOnChange}
                                                        className={'custom-quill-message'}
                                                        value={this.state.textAreaValue}
                                                        theme={'snow'}
                                                    />
                                                    {/* <div
                                                            contentEditable={true}
                                                            className="form-control message-input-text"
                                                            placeholder={T.t('r_message_place_holder')}
                                                            onKeyDown={this.onKeyDown}
                                                            ref={e => (this.chatInput = e)}
                                                        /> */}
                                                    <div className="input-group-append">
                                                        {this.state.getQuillToolbarModule !== EModuleType.mobile ? (
                                                            <div>
                                                                {this.state.showEmojiPicker ? (
                                                                    <ChatEmojiPicker
                                                                        onSelect={this.addEmoji}
                                                                        handleClickOutside={this.toggleEmojiPicker}
                                                                        ref={e => (this.chatEmojiPicker = e)}
                                                                        locale={T.i18next.language}
                                                                    />
                                                                ) : null}
                                                                <div className='r-d-flex'>
                                                                    <span className="input-group-text" onClick={this.toggleEmojiPicker}>
                                                                        <i className="material-icons">tag_faces</i>
                                                                    </span>

                                                                    {this.state.fileUploaded ? (
                                                                        <>
                                                                            <span className="input-group-text" onClick={this.showFileUploader}>
                                                                                <i className="material-icons">attach_file</i>
                                                                            </span>
                                                                            <span
                                                                                style={{ height: '16px', color: 'red', marginLeft: '0px', cursor: 'pointer' }}
                                                                                title="Dosyayı sil"
                                                                                className="badge badge-pill badge-light"
                                                                                onClick={this.resetFileUploader}
                                                                            >
                                                                                x
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <span className="input-group-text" onClick={this.showFileUploader}>
                                                                            <i className="material-icons">add</i>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                        <button onClick={() => this.sendHandler(true)} disabled={this.state.isLoadingProcess} className="input-group-text" style={{ border: 'none', background: 'none' }}>
                                                            <i style={{ marginRight: '5px' }} className="material-icons">
                                                                send
                                                            </i>
                                                            <div style={{ paddingInlineStart: "5px" }}>
                                                                {this.state.isLoadingProcess ? T.t('r_gen_sending') : T.t('r_send')}
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </>
            );
        }
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }

    const newProps: any = Object.assign({}, ownProps, {
        messages: state.message.messages,
        identity: state.login.identitiy,
        chatSkip: state.message.chatSkip,
        chatTake: state.message.chatTake,
        chatTitleImages: state.message.chatTitleImages,
        chatTitleText: state.message.chatTitleText,
        chatTotal: state.message.chatTotal,
        currentContextId: state.message.currentContextId,
        currentContextType: state.message.currentContextType,
        originMessageId: state.message.originMessageId,
        messageListTake: state.message.messageListTake
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.message === prev.message &&
        next.login.identitiy === prev.login.identitiy &&
        next.message.chatSkip === prev.message.chatSkip &&
        next.message.chatTake === prev.message.chatTake &&
        next.message.chatTitleImages === prev.message.chatTitleImages &&
        next.message.chatTitleText === prev.message.chatTitleText &&
        next.message.chatTotal === prev.message.chatTotal &&
        next.message.currentContextId === prev.message.currentContextId &&
        next.message.currentContextType === prev.message.currentContextType &&
        next.message.originMessageId === prev.message.originMessageId;
    return ret;
};

const ChatPanel = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CChatPanel);

export default ChatPanel;
